import { Grid, Typography } from '@mui/material';
import { cpdFormConfig, CpdFormMode } from './cpdFormConfig';

interface Props {
    mode: CpdFormMode;
}

export default function CpdCategoryIntroduction({ mode }: Props) {
    const { title, description } = cpdFormConfig[mode];

    return <>
        <Grid container rowSpacing={1} sx={{ marginLeft: "2%", marginTop: "1%" }}>

            <Grid size={{ xs: 12 }}>
                <Typography variant='h4'>{title}</Typography>
            </Grid>

            <Grid size={{ xs: 12 }}></Grid>

        </Grid>
        {typeof description === 'string' ? <Grid container sx={{ ml: "2%", mt: "2%", mb: "3%" }}>
            <Grid size={{ xs: 12 }}>
                <Typography variant='subtitle1'>{description}</Typography>
            </Grid>
        </Grid> : description}
    </>;
}
